<template>
  <div class="animated fadeIn">
    <b-tabs>
      <b-tab title="Analytes" active>
        <SampleAnalyteTable :analytes="sample.analytes" />
      </b-tab>

      <b-tab title="Results">
        <SampleResultTable />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import SampleAnalyteTable from '@/components/lab/samples/SampleAnalyteTable.vue'
import SampleResultTable from '@/components/lab/samples/SampleResultTable.vue'

export default {
  name: 'SampleDetailCardstack',
  components: {
    SampleAnalyteTable,
    SampleResultTable
  },
  props: {
    sample: {
      type: Object,
      default () {
        return null
      }
    }
  }
}
</script>
